import BioView from "./BioView";

export default BioView;
